<template>
  <div class="page-content">
    <div class="page-main">
      <SchoolBaseNavBar />
      <div class="m-filters">
        <div class="block">
          <span class="demonstration">时间范围：</span>
          <el-date-picker
            v-model="time"
            @change="getDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <div class="tip">
            <i class="iconfont icon-tishiii"></i>
            数据按小时更新~
          </div>
          <div class="export-btn" data-io-click="tracker"  @click.stop="exportFile">
            <i class="iconfont icon-shangchuanziyuan"></i>导出
          </div>
        </div>
      </div>
      <div class="mbody">
        <div class="title"><span>数据概览</span></div>
        <div class="conbox">
          <div class="box box-1">
            <span>上传量</span>
            <p>
              <b>{{ allDate.uploadCount }}</b
              >份
            </p>
            <img src="@/assets/images/icon-1.png" alt="" />
          </div>
          <div class="box box-2">
            <span>上传人数</span>
            <p>
              <b>{{ allDate.uploaderCount }}</b
              >人
            </p>
            <img src="@/assets/images/icon-2.png" alt="" />
          </div>
          <div class="box box-3">
            <span>下载次数</span>
            <p>
              <b>{{ allDate.downloadCount }}</b
              >次
            </p>
            <img src="@/assets/images/icon-3.png" alt="" />
          </div>
          <div class="box box-4">
            <span>下载人数</span>
            <p>
              <b>{{ allDate.downloaderCount }}</b
              >人
            </p>
            <img src="@/assets/images/icon-4.png" alt="" />
          </div>
        </div>
        <div class="table" v-if="schoolListShow">
          <div class="thead">
            <span>名称</span>
            <span>上传量</span>
            <span>上传人数</span>
            <span>下载次数</span>
            <span>下载人数</span>
          </div>
          <div class="tbody all" v-loading="loadingAllData">
            <div
              class="tr"
              v-for="(item, index) in schoolDateList"
              :key="index"
            >
              <span>{{ item.title }}</span>
              <span>{{ item.uploadCount }} 份</span>
              <span>{{ item.uploaderCount }} 人</span>
              <span>{{ item.downloadCount }} 次</span>
              <span>{{ item.downloaderCount }} 人</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mbody">
        <div class="title">
          <span>学科数据</span>
          <div class="tab-nav" v-if="schoolListShow">
            <span
              v-for="(item, id) in basicStage"
              :key="id"
              :class="{ current: currentSubjectItem === (item.id || '') }"
              data-io-click="tracker"  @click="changeSubject(item)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
        <div class="table">
          <div class="thead">
            <span>名称</span>
            <span
              v-for="(item, index) in SubjectHeaderData"
              :key="index"
              data-io-click="tracker"  @click="clikcRankSubject(item.count, index)"
              :class="index == currentIndexSub ? 'current' : ''"
            >
              {{ item.name }}<i class="iconfont icon-arrow-fill"></i>
            </span>
          </div>
          <div class="tbody" v-loading="loadingSubjectData">
            <div
              class="tr"
              v-for="(item, index) in subjectDateList"
              :key="index"
            >
              <span>
                <b>
                  <i v-if="item.num == 1">
                    <img src="../../assets/images/level-1.png" />
                  </i>
                  <i v-if="item.num == 2">
                    <img src="../../assets/images/level-2.png" />
                  </i>
                  <i v-if="item.num == 3">
                    <img src="../../assets/images/level-3.png" />
                  </i>
                  <i v-if="item.num > 3">{{ item.num }}</i>
                  {{ item.title }}
                </b>
              </span>
              <span>{{ item.uploadCount }} 份</span>
              <span>{{ item.uploaderCount }} 人</span>
              <span>{{ item.downloadCount }} 次</span>
              <span>{{ item.downloaderCount }} 人</span>
            </div>
          </div>
          <div class="pages" v-if="totalCountSub >= pageSizeSub">
            <el-pagination
              background
              @size-change="pageSizeChangeSub"
              @current-change="pageIndexChangeSub"
              :current-page="pageIndexSub"
              :page-sizes="pageSizesSub"
              :page-size="pageSizeSub"
              layout="total, sizes, prev, pager, next, jumper"
              :page-count="totalPagesSub"
              :total="totalCountSub"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="mbody">
        <div class="title">
          <span>教师数据</span>
          <div class="tab-nav" v-if="schoolListShow">
            <span
              v-for="(item, id) in basicStage"
              :key="id"
              :class="{ current: currentTeacherItem === (item.id || '') }"
              data-io-click="tracker"  @click="changeTeacher(item)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
        <div class="table table-teacher-data">
          <div class="thead">
            <span>名称</span>
            <span
              v-for="(item, index) in teacherHeaderData"
              :key="index"
              data-io-click="tracker"  @click="clikcRankTeacher(item.count, index)"
              :class="index == currentIndexTer ? 'current' : ''"
            >
              {{ item.name }}<i class="iconfont icon-arrow-fill"></i>
            </span>
          </div>
          <div class="empty-list" v-if="isNoData">
            <img data-v-724d760b="" src="/img/empty.cdbc913a.png" alt="" /><span
              data-v-724d760b=""
              class="text"
              >暂无数据</span
            >
          </div>
          <div class="tbody" v-else v-loading="loadingTeachertData">
            <div
              class="tr"
              v-for="(item, index) in teacherDateList"
              :key="index"
            >
              <span>
                <b :title="item.name">
                  <i v-if="item.num == 1">
                    <img src="../../assets/images/level-1.png" />
                  </i>
                  <i v-if="item.num == 2">
                    <img src="../../assets/images/level-2.png" />
                  </i>
                  <i v-if="item.num == 3">
                    <img src="../../assets/images/level-3.png" />
                  </i>
                  <i v-if="item.num > 3">{{ item.num }}</i>
                  {{ item.name }}
                </b>
              </span>
              <span>{{ item.uploadCount }} 份</span>
              <span>{{ item.approvedCount }} 份</span>
              <span>{{ item.downloadCount }} 次</span>
              <span>{{ item.useCount }} 次</span>
            </div>
          </div>
          <div class="pages" v-if="totalCount >= pageSize">
            <el-pagination
              background
              @size-change="pageSizeChange"
              @current-change="pageIndexChange"
              :current-page="pageIndex"
              :page-sizes="pageSizes"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :page-count="totalPages"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUserInfo,
  getSchoolStages,
  getSchoolStatistics,
  getSubjectStatistics,
  getTeacherStatistics,
  handleStatisticsLoad,
} from "@/utils/apis";
import api from "@/assets/js/service/api";
import request from "@/utils/request";
import SchoolBaseNavBar from "@/components/SchoolBaseNavBar";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 3600 * 1000 * 24 * 365 ||
            // time.getTime() > Date.now() - 3600 * 1000 * 24 * 1
            time.getTime() > Date.now()
          );
        },
      },
      // 默认显示近一个月的数据
      time: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
        // new Date(new Date().getTime() - 3600 * 1000 * 24 * 1),
        new Date(new Date().getTime()),
      ],
      // 时间范围选择开始时间
      startDateTime: "",
      // 时间范围选中结束时间
      endDateTime: "",
      // 学校ID
      schoolId: "",
      // 学校的全部数据  数据概览
      allDate: "",
      schoolListShow: true,
      // 学校数据列表
      schoolDateList: [],
      // 学科数据列表
      subjectDateList: [],
      // 教师数据列表
      teacherDateList: [],
      // 全部学科
      basicStage: [],
      // 学段ID
      stageIdSub: "",
      stageIdTer: "",
      // 筛选学科 当前选中的学段
      currentSubjectItem: "",
      // 筛选教师 当前选中的学段
      currentTeacherItem: "",
      currentItem: "",
      // 筛选无数据
      isNoData: false,

      // 当前页码
      pageIndex: 1,
      // 每页显示条数
      pageSize: 10,
      // 总页数
      totalPages: 0,
      // 资料总数
      totalCount: 0,
      // 分页条数的列表
      pageSizes: [10, 20, 30],

      // 当前页码
      pageIndexSub: 1,
      // 每页显示条数
      pageSizeSub: 10,
      // 总页数
      totalPagesSub: 0,
      // 资料总数
      totalCountSub: 0,
      // 分页条数的列表
      pageSizesSub: [10, 20, 30],

      // 学校角色
      roles: [],
      // 默认以上传量排序
      ordersSub: ["uploadCount$2"],
      ordersTer: ["uploadCount$2"],
      // loading
      loadingAllData: true,
      loadingSubjectData: true,
      loadingTeachertData: true,
      // 学科列表表头
      SubjectHeaderData: [
        { count: "uploadCount", name: "上传量" },
        { count: "uploaderCount", name: "上传人数" },
        { count: "downloadCount", name: "下载次数" },
        { count: "downloaderCount", name: "下载人数" },
      ],
      currentIndexSub: 0,
      // 教师列表表头
      teacherHeaderData: [
        { count: "uploadCount", name: "上传量" },
        { count: "approvedCount", name: "审核通过量" },
        { count: "downloadCount", name: "下载次数" },
        { count: "useCount", name: "被使用次数" },
      ],
      currentIndexTer: 0,
      userInfo: null,
    };
  },
  mounted() {
    // 获取用户信息
    this.getUserInfo();
    // 获取学段
    this.getSchoolStages();
    // 选择时间获取数据
    this.getDate(this.time);
  },
  components: { SchoolBaseNavBar },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      const res = await getUserInfo();
      // console.log("res", res);
      this.userInfo = res.result;
      if (res.code === 200) {
        this.schoolId = res.result.schoolId;
        this.roles = res.result.roles;
      }
    },
    // 导出文档
    async exportFile() {
      // window.open(
      //   `https://wxt.xkw.com/wxtapi/${api.schoolbase.statisticsLoad}?startTime=${this.startDateTime}&endTime=${this.endDateTime}`
      // );
      let data = await request.downLoadBuffer(api.schoolbase.statisticsLoad, {
        startTime: this.startDateTime,
        endTime: this.endDateTime,
      });
      // const fileNameEncode =
      //   res.headers["content-disposition"].split("filename=")[1];
      // 解码
      // const fileName = decodeURIComponent(fileNameEncode);
      // console.log("fileName", fileName);
      // 设置type类型
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; application/octet-stream",
      });
      const fileUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileUrl;
      // console.log("url", fileUrl);
      let endDateTime = this.endDateTime
        .split("-")
        .map((date) => (date.length < 2 ? "0" + date : date))
        .join("");
      let startDateTime = this.startDateTime
        .split("-")
        .map((date) => (date.length < 2 ? "0" + date : date))
        .join("");
      a.setAttribute(
        "download",
        this.userInfo.schoolName +
          "校本数据" +
          startDateTime +
          "-" +
          endDateTime
      );
      a.style.display = "none";
      a.click();
      a.remove();
    },
    // 获取学段
    async getSchoolStages() {
      const result = [];
      const res = await getSchoolStages(true);
      if (res.code === 200) {
        this.basicStage = res.result;
      }
      this.basicStage.unshift({ id: "", name: "全部" });
    },
    // 获取全部学科信息
    async getAllSubject() {
      const subjectData = await getSubjectStatistics({
        endTime: this.endDateTime,
        orders: this.ordersSub,
        pageIndex: this.pageIndexSub,
        pageSize: this.pageSizeSub,
        startTime: this.startDateTime,
      });
      if (subjectData.result.list && subjectData.result.list.length > 0) {
        this.subjectDateList = subjectData.result.list;
        this.totalPagesSub = subjectData.result.totalPages;
        this.totalCountSub = subjectData.result.totalCount;
      }
      this.loadingSubjectData = false;
    },
    // 获取筛选学科
    async getPartSubject() {
      // 获取学科数据
      const subjectData = await getSubjectStatistics({
        endTime: this.endDateTime,
        orders: this.ordersSub,
        pageIndex: this.pageIndexSub,
        pageSize: this.pageSizeSub,
        stageId: this.stageIdSub,
        startTime: this.startDateTime,
      });
      if (subjectData.result.list && subjectData.result.list.length > 0) {
        this.subjectDateList = subjectData.result.list;
        this.totalPagesSub = subjectData.result.totalPages;
        this.totalCountSub = subjectData.result.totalCount;
      }
      this.loadingSubjectData = false;
    },
    // 获取全部教师
    async getAllTeacher() {
      const teacherData = await getTeacherStatistics({
        endTime: this.endDateTime,
        orders: this.ordersTer,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        startTime: this.startDateTime,
      });
      if (teacherData.result.list && teacherData.result.list.length > 0) {
        this.isNoData = false;
        this.teacherDateList = teacherData.result.list;
        this.totalPages = teacherData.result.totalPages;
        this.totalCount = teacherData.result.totalCount;
      } else {
        this.isNoData = true;
      }
      this.loadingTeachertData = false;
    },
    // 获取筛选教师
    async getPartTeacher() {
      const teacherData = await getTeacherStatistics({
        endTime: this.endDateTime,
        orders: this.ordersTer,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        stageId: this.stageIdTer,
        startTime: this.startDateTime,
      });
      if (teacherData.result.list && teacherData.result.list.length > 0) {
        this.isNoData = false;
        this.teacherDateList = teacherData.result.list;
        this.totalPages = teacherData.result.totalPages;
        this.totalCount = teacherData.result.totalCount;
      } else {
        this.isNoData = true;
      }
      this.loadingTeachertData = false;
    },
    async getDate(val) {
      this.time = val;
      let startTime = this.time[0];
      let endTime = this.time[1];
      this.startDateTime =
        startTime.getFullYear() +
        "-" +
        (startTime.getMonth() + 1) +
        "-" +
        startTime.getDate();
      this.endDateTime =
        endTime.getFullYear() +
        "-" +
        (endTime.getMonth() + 1) +
        "-" +
        endTime.getDate();
      this.startDateTime.toString();
      this.endDateTime.toString();
      // 获取学校数据
      const schoolData = await getSchoolStatistics({
        endTime: this.endDateTime,
        schoolId: this.schoolId,
        startTime: this.startDateTime,
      });
      if (schoolData.result) {
        this.allDate = schoolData.result[0];
        this.schoolDateList = schoolData.result.slice(1);
        if (this.schoolDateList.length < 2) {
          this.schoolListShow = false;
        }
      }
      this.loadingAllData = false;
      this.currentSubjectItem = "";
      this.currentTeacherItem = "";
      (this.ordersSub = ["uploadCount$2"]),
        (this.ordersTer = ["uploadCount$2"]),
        (this.currentIndexSub = 0);
      this.currentIndexTer = 0;
      this.pageIndex = 1;
      this.pageIndexSub = 1;
      // 获取全部学科数据
      this.getAllSubject();
      // 获取全部教师数据
      this.getAllTeacher();
    },
    //学科排序
    clikcRankSubject(order, index) {
      this.currentIndexSub = index;
      this.ordersSub = [order + "$2"];
      if (!this.stageIdSub) {
        this.getAllSubject();
      } else {
        this.getPartSubject();
      }
    },
    // 教师排序
    clikcRankTeacher(order, index) {
      this.currentIndexTer = index;
      this.ordersTer = [order + "$2"];
      if (!this.stageIdTer) {
        this.getAllTeacher();
      } else {
        this.getPartTeacher();
      }
    },
    // 切换学段筛选学科
    changeSubject(subject) {
      this.currentSubjectItem = subject.id;
      this.stageIdSub = subject.id;
      this.pageIndex = 1;
      this.pageIndexSub = 1;
      subject.id == "" ? this.getAllSubject() : this.getPartSubject();
    },
    //切换学段筛选教师
    changeTeacher(teacher) {
      this.currentTeacherItem = teacher.id;
      this.stageIdTer = teacher.id;
      this.pageIndex = 1;
      this.pageIndexSub = 1;
      teacher.id == "" ? this.getAllTeacher() : this.getPartTeacher();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
    },
    // 切换每页显示条数 学科
    pageSizeChangeSub(val) {
      this.pageIndexSub = 1;
      this.pageSizeSub = val;
      if (!this.stageIdSub) {
        this.getAllSubject();
      } else {
        this.getPartSubject();
      }
    },
    // 翻页功能 学科
    pageIndexChangeSub(val) {
      this.pageIndexSub = val;
      if (!this.stageIdSub) {
        this.getAllSubject();
      } else {
        this.getPartSubject();
      }
    },
    // 切换每页显示条数 教师
    pageSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      if (!this.stageIdTer) {
        this.getAllTeacher();
      } else {
        this.getPartTeacher();
      }
    },
    // 翻页功能  教师
    pageIndexChange(val) {
      this.pageIndex = val;
      if (!this.stageIdTer) {
        this.getAllTeacher();
      } else {
        this.getPartTeacher();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  // position: relative;
  // height: 100%;
  // width: 100%;
  // padding: 0px 0px 0 45px;
  padding: 56px 0 0;

  .page-main {
    width: 100%;
    padding: 0;

    .m-filters {
      padding: 18px 25px;
      border-radius: 8px;
      background: #fff;
      overflow: auto;
      margin-bottom: 16px;

      .demonstration {
        font-size: 14px;
        color: #333;
      }

      .el-range-editor.el-input__inner {
        width: 300px;
        border-radius: 8px;
      }

      ::v-deep .el-date-editor {
        .el-range-separator {
          width: 7%;
        }
      }

      .tip {
        margin-left: 25px;
        display: inline-block;
        height: 26px;
        line-height: 26px;
        background: #fff2e6;
        border-radius: 6px;
        padding: 0 13px;
        box-sizing: border-box;
        font-size: 12px;
        color: #fe9737;

        .iconfont {
          font-size: 14px;
        }
      }

      .export-btn {
        display: inline-block;
        font-size: 14px;
        border-radius: 8px;
        background: #0057ff;
        color: #fff;
        cursor: pointer;
        padding: 10px 20px;
        line-height: 1;
        float: right;
        margin-top: 2.5px;

        .iconfont {
          display: inline-block;
          margin-right: 6px;
          font-size: 15px;
          transform: rotateZ(90deg);
        }
      }
    }

    .mbody {
      padding: 0;
      border-radius: 8px;
      background: #fff;
      overflow: auto;
      margin-top: 6px;

      .title {
        border-bottom: 1px solid #e6e7e9;

        span {
          padding: 20px 30px;
          line-height: 1;
          font-size: 18px;
          color: #333333;
          display: inline-block;
        }

        .tab-nav {
          display: inline-block;
          margin-left: 70px;

          span {
            padding: 5px 10px;
            line-height: 1;
            font-size: 14px;
            color: #333333;
            display: inline-block;
            margin: 0 5px;
            cursor: pointer;

            &.current {
              background: #e5f7fe;
              border: 1px solid #0057ff;
              border-radius: 6px;
              color: #0057ff;
            }
          }
        }
      }

      .conbox {
        padding: 28px 10px;

        .box {
          width: calc(25% - 25px);
          vertical-align: middle;
          height: 110px;
          opacity: 0.9;
          background: #4184f5;
          border-radius: 10px;
          display: inline-block;
          color: #fff;
          padding: 23px 25px;
          box-sizing: border-box;
          position: relative;
          margin-left: 20px;

          span {
            font-size: 14px;
          }

          p {
            font-size: 14px;
            padding-top: 10px;

            b {
              font-size: 30px;
              font-weight: normal;
              padding-right: 5px;
            }
          }

          img {
            width: 42px;
            height: 42px;
            display: inline-block;
            position: absolute;
            top: 23px;
            right: 25px;
          }

          &.box-1 {
            background: #4184f5;
          }

          &.box-2 {
            background: #fc5886;
          }

          &.box-3 {
            background: #7583ff;
          }

          &.box-4 {
            background: #f56b56;
          }
        }
      }

      .table {
        margin: 12px 30px;
        border-radius: 8px;
        overflow: hidden;

        &.table-teacher-data {
          span {
            width: 20%;
          }
        }

        span {
          width: 20%;
          font-size: 16px;
          color: #80848b;
          text-align: center;
          line-height: 1;
          display: inline-block;
          cursor: pointer;

          &.current {
            i {
              color: #0057ff;
            }
          }

          i {
            width: 16px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 10px;
            font-style: normal;
            color: #80848b;
            font-size: 12px;

            img {
              width: 100%;
            }
          }
        }

        .thead {
          background: #e5f7fe;
          padding: 18px;
          font-size: 0;
          letter-spacing: 0;
        }

        .tbody {
          font-size: 0;
          letter-spacing: 0;

          &.all {
            .tr {
              &:nth-child(odd) {
                background: #fff;
              }

              &:nth-child(even) {
                background: rgba(216, 216, 216, 0.3);
              }
            }
          }

          .tr {
            padding: 18px;

            span {
              height: 20px;
              font-size: 14px;
              color: #333;

              b {
                // min-width: 140px;
                // display: inline-block;
                // text-align: left;
                // font-weight: normal;
                width: 150px;
                display: inline-block;
                text-align: left;
                font-weight: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }

          .tr:nth-child(odd) {
            background: rgba(216, 216, 216, 0.3);
          }
        }
      }
    }
  }
}

.empty-list {
  padding: 160px 0 100px;
  text-align: center;
  background: #fff;

  .text {
    width: 100% !important;
    margin-top: 20px;
    display: block;
    font-size: 14px;
    color: #333;
  }
}
</style>
